module.exports = __webpack_public_path__ + "img/icon-select-down-white.5f86030b.svg";